"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SelectWidgetTypeController;
/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/*@ngInject*/
function SelectWidgetTypeController($mdDialog, types) {

    var vm = this;

    vm.types = types;

    vm.cancel = cancel;
    vm.typeSelected = typeSelected;

    function cancel() {
        $mdDialog.cancel();
    }

    function typeSelected(widgetType) {
        $mdDialog.hide(widgetType);
    }
}


// WEBPACK FOOTER //
// ./src/app/widget/select-widget-type.controller.js